export default __webpack_public_path__ + "static/media/java.3d1f1777.svg";